import { useMemo } from 'react';

import { NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, toggleFormatter, defaultColumnId, booleanFormatter } from '@Components/Grid/utils/column';

import EntityTipFormatter from './EntityTipFormatter'

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    column.accessor('path', {
      header: 'Description',
      cell: info => <NameAndCreateDateFormatter info={info} link={false} />,
      size: 300,
    }),
    column.accessor('entity', {
      header: 'Entity',
      cell: info => <EntityTipFormatter info={info} />,
    }),
    defaultColumn('content_type', 'Type'),
    defaultColumn('is_custom', 'Custom Route', booleanFormatter),
    defaultColumn('is_config', 'Config Route', booleanFormatter),
    defaultColumn('is_home', 'Is Home', toggleFormatter),
  ], [])
}
